import cookie from 'vue-cookie';
import jwtDecode from 'jwt-decode';
import store from '../store';
/* import router from '../router'; */

export const login = (token) => {
	cookie.set('admtoken', token, {
		host: window.location.host,
		expires: 365,
	});
	store.dispatch('setToken', token);

	const decoded = jwtDecode(token);

	const user = {
		cod_usuario: decoded.sub,
		usuario: decoded.user,
		email: decoded.email,
	};
	store.dispatch('setUser', user);
};

export const setUser = (logUser = '') => {
	store.dispatch('setLogUser', logUser);
	cookie.set('logUser', logUser, 365);
};

export const lockScreen = () => {
	/*  store.dispatch('logoff');

  cookie.delete('token');
  cookie.delete('user');
 */
	cookie.delete('admtoken', {
		host: window.location.host,
	});

	cookie.delete('user', {
		host: window.location.host,
	});
};

export const logoff = () => {
	const tokencookie = cookie.delete('admtoken', {
		host: window.location.host,
	});
	if (tokencookie) {
		cookie.delete('admtoken', {
			host: window.location.host,
		});
	}
	cookie.delete('logUser');
	window.location.href = '/login';
};

export const isAuthenticated = () => {
	const tokenCookie = cookie.get('admtoken', {
		host: window.location.host,
	});

	if (!tokenCookie) {
		return false;
	}
	return true;
};

export const getUser = () => {
	const tokenCookie = cookie.get('admtoken', {
		host: window.location.host,
	});

	const decoded = jwtDecode(tokenCookie);

	return decoded.user;
};

export const validateSession = () => {
	const tokenCookie = cookie.get('admtoken', {
		host: window.location.host,
	});
	const { user } = store.getters;

	if (tokenCookie === '') {
		if (tokenCookie == null || tokenCookie === '') {
			logoff();
		} else {
			store.dispatch('setToken', tokenCookie);
		}
	} else if (tokenCookie == null || tokenCookie === '') {
		logoff();
	}

	if (store.getters.user.length === 0) {
		if (user === null || user === '') {
			logoff();
		} else {
			const decoded = jwtDecode(tokenCookie);
			const userdata = {
				cod_usuario: decoded.sub,
				usuario: decoded.user,
				email: decoded.email,
			};
			store.dispatch('setUser', userdata);
		}
	} else if (user == null || user === '') {
		logoff();
	}
};

// Verifica se usuário possui permissão para acessar as páginas protegidas.
export const hasPermisssion = (permissions, access) => {
	let hasPermisssionR = true;

	if (access === 'novoAtendimento' && permissions.criaratendimento === 0) {
		hasPermisssionR = false;
	} else if (access === 'editarAtendimento' && permissions.editaratendimento === 0) {
		hasPermisssionR = false;
	}

	return hasPermisssionR;
};
